import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { mailingAPI } from '../../services/api';

const MailingUnsubscribe = () => {
  const { token } = useParams();
  const [row, setRow] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    mailingAPI.lookup(token).then((response) => setRow(response.data)).catch(() => setMessage('找不到此訂閱'));
  }, [token]);

  const confirm = async () => {
    try {
      const response = await mailingAPI.unsubscribe(token);
      setMessage(response.data.message || '已取消訂閱');
      setRow((current) => ({ ...current, is_unsubscribed: true }));
    } catch (err) {
      setMessage('取消失敗');
    }
  };

  return (
    <section className="container" style={{ padding: '2rem 1rem', maxWidth: 640 }}>
      <h1>取消訂閱</h1>
      {row && !row.is_unsubscribed && (
        <>
          <p>{row.display_name ? `${row.display_name}，` : ''}確認不再接收會務通訊？</p>
          <button type="button" className="btn btn-primary" onClick={confirm}>確認取消訂閱</button>
        </>
      )}
      {row?.is_unsubscribed && <p>已取消訂閱</p>}
      {message && <p>{message}</p>}
    </section>
  );
};

export default MailingUnsubscribe;
